<template>
    <div class="col-12 mb-primary">
        <div class="card card-with-shadow border-0 h-100">
            <div class="card-header p-primary bg-transparent">
                <h5 class="card-title m-0">{{ $t('cms_update') }}</h5>
            </div>
            <app-overlay-loader v-if="preloader"/>
            <div class="card-body">
                 <form ref="form" :data-url='`/cms/update/${cmsdata.id}`' class="mb-0" :class="{'loading-opacity': preloader}" enctype="multipart">
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('parent') }}
                        </label>

                        <app-input class="col-md-8"
                                   type="select"
                                   v-model="cmsdata.pid"
                                   :list="categories"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('title') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="cmsdata.title"
                                   :required="true"
                                   :placeholder="$t('title_name')"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('sub_title') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="cmsdata.sub_title"
                                   :required="false"
                                   :placeholder="$t('sub_title_name')"/>
                    </div>
                    <div class="form-group row">
                        <label for="inputs_editor" class="col-sm-2 h-fit-content">
                            {{ $t('content') }}
                        </label>
                        <div class="col-sm-8">
                            <app-input type="text-editor"
                                       :required="false"
                                       id="text-editor-id"
                                       :label="$t('message_placeholder')" v-model="cmsdata.description"/>
                        </div>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('meta_keyword') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="cmsdata.meta_keyword"
                                   :required="false"
                                   :placeholder="$t('meta_key_name')"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('meta_title') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="cmsdata.meta_title"
                                   :required="false"
                                   :placeholder="$t('meta_title_name')"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('meta_description') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="cmsdata.meta_description"
                                   :required="false"
                                   :placeholder="$t('meta_description_name')"/>
                    </div> 
                    <div class="form-group row mb-0">
                        <label class="col-sm-2 mb-sm-0">
                            {{ $t('upload_image') }}
                            <small class="text-muted font-italic">
                                {{ $t('recommended_slider_size') }}
                            </small>
                        </label>
                        <div class="col-sm-4">
                            <app-input type="custom-file-upload"
                                       :label="$t('upload_your_file')"
                                       v-model="inputs.featured_image"/>
                        </div>
                        <div class="custom-image-upload-wrapper" v-if="cmsdata.featured_image">
                            <app-avatar :title="$t('avatars')" class="image-area d-flex" :img="cmsdata.featured_image"
                                  :alt-text="$t('not_found')"/>         
                        </div>
                    </div>

                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('status') }}
                        </label>
                            <app-input class="col-md-8 mt-2 pt-1"
                                       type="radio"
                                       :list="statusLists"
                                       v-model="cmsdata.status"/>
                    </div>
                    <div class="mt-5 action-buttons">
                        <button type="submit" class="btn btn-primary mr-2" @click.prevent="submit">
                            {{ $t('submit')}}
                        </button>
                        <button type="submit" class="btn btn-secondary" @click.prevent="clear">
                            {{ $t('clear') }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import {axiosPost} from "../../../../Helpers/AxiosHelper";  
    import {FormMixin} from "../../../../../core/mixins/form/FormMixin"; 
    import * as actions from '../../../../Config/ApiUrl';
    export default {
        name: "UpdateCMS",
        mixins: [FormMixin],
        props: ['cmsdata','categories'],
        data(){
          return {            
            preloader: false, 
            inputs: {},               
                statusLists: [
                    {id: 'active', value: "Active"},
                    {id: 'inactive', value: "Inactive"},
                ]
          }
        },
        methods: {
            beforeSubmit(){
                this.preloader = true;
            },
            submit() {
                let formData = new FormData;
                for (const [key, value] of Object.entries(this.cmsdata)) {                  
                  if (value != null) formData.append(key, value);
                }
                if (this.inputs.featured_image) {
                    formData.append("featured_image", this.inputs.featured_image);
                }
                this.save(formData);
            },
            afterSuccess(res) {
                this.$toastr.s(res.data.message);
                window.location.reload();
            },
            afterFinalResponse() {
                this.preloader = false;
            },
            afterError(res) {
                this.$toastr.e(res.data.message);
            },
            clear() {
                this.fieldStatus = {
                    isSubmit: false
                }
            },
        }
    }
</script>